module.exports = __webpack_public_path__ + "img/copy-icon.568b3b7e.svg";